import { cx } from "@emotion/css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { IconButton } from "@mui/material";
import { useFormikContext } from "formik";
import useDebounce from "hooks/useDebounce";
import useDeviceType from "hooks/useDeviceType";
import DefaultInput from "library/Atoms/Input/DefaultInput";
import Filter from "library/Molecules/Filter";
import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles";

const SearchFilter = () => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceType();

  const {
    values: { search },
    setFieldValue,
  } = useFormikContext();

  const searchFilterRef = useRef();

  const onChange = useCallback(
    (name, value) => {
      searchFilterRef.current?.closeMenu?.();
      if (search === value) return;
      setFieldValue(name, value);
    },
    [search, setFieldValue]
  );
  const onClearInput = useCallback(() => onChange("search", ""), [onChange]);

  const handleChangeValue = useDebounce(onChange, 450);

  return (
    <Filter
      id="list-search-filter"
      ref={searchFilterRef}
      className="p-4"
      label={!isMobile && search && <>{search}</>}
      icon={<SearchRoundedIcon fontSize="small" />}
      badge={isMobile && search}
    >
      <DefaultInput
        name="search"
        className={styles.container}
        placeholder={t("features.filtersForm.searchFilterPlaceholder")}
        value={search}
        InputProps={{
          className: "w-100",
          endAdornment: (
            <IconButton id="list-search-filter-clear-btn" className="p-0" onClick={onClearInput}>
              <CloseRoundedIcon className={cx(styles.icon)} />
            </IconButton>
          ),
        }}
        onChange={handleChangeValue}
      />
    </Filter>
  );
};

export default SearchFilter;
